<template>
	<div class="home">
		<!-- nav工具栏 -->
		<div class="user clearfix ">
				<div class="userName">
					<div class="home-title">{{timeText}},<span>{{userInfo.nickName}}</span></div>
				</div>
				<div class="control">
					<van-icon class="cross" name="search" size="20" color="#fff" @click="showPopup" />
					<van-popup v-model="show" closeable position="top" :style="{ height: '70%' }">
						<div>
							<van-search v-model="value" style="width: 85%;" placeholder="请输入搜索关键词" clearable @input="getSearchData" />
						</div>
						<div class="sear-product">
							<div class="sear-product-box">
								<div class="sear-product-item clearfix" v-for="(item,index) in searchData" :key="index" @click="viewProductInfo(item.pid)">
									<div class="sear-product-img fl">
										<img class="auto-img" :src="item.smallImg" alt="">
									</div>
									<div class="sear-name fr">
										<p class="sname">{{item.name}}</p>
										<p class="sename">{{item.enname}}</p>
									</div>
								</div>
							</div>
						</div>
					</van-popup>
					<van-icon class="cross" name="scan" size="20" color="#fff" />
					<van-icon class="cross" name="vip-card-o" size="20" color="#fff" />
				</div>
		</div>

		<!-- 轮播图 -->
		<div class="banner-box">
			<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
				<!-- van-swipe-item v-for="(item,index) in bannerData" :key="index"><img class="auto-img" :src="item.bannerImg" alt=""></van-swipe-item> -->
				<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_1.png" alt=""></van-swipe-item>
				<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_2.png" alt=""></van-swipe-item>
				<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_3.png" alt=""></van-swipe-item>
				<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_4.png" alt=""></van-swipe-item>
				<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_5.png" alt=""></van-swipe-item>
				<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_6.png" alt=""></van-swipe-item>
				<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_7.png" alt=""></van-swipe-item>
				<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_8.png" alt=""></van-swipe-item>
			</van-swipe>
		</div>
		
		<!-- 热门推荐 -->
		<div class="hot-product">
			<div class="hot-product-title">
				热门推荐
			</div>
			<div class="product-box clearfix">
				<div class="product-item fl" :class="[index % 2 == 0 ? 'p-left' : 'p-right']" v-for="(item,index) in ishotData" :key="index" @click="viewProductInfo(item.pid)">
					<div class="p-img">
						<img class="auto-img" :src="item.largeImg" alt="">
					</div>
					<div class="clearfix product-description">
						<div class="pro-name one-text">{{item.name}}</div>
						<div class="pro-price">{{item.price}}元</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/less/home.less'
	export default {
		name: 'Home',
		data() {
			return {
				show: false,
				value: '',
				timeText: '',
				bannerData: [],
				ishotData: [],
				searchData: [],
				userInfo:[]
			};
		},
		
		created(){
			this.getTime();
			// this.getbannerData();
			this.getishotData();
			this.getUserInfo();
		},
		
		methods: {
			showPopup() {
				this.show = true;
			},
			
			//获取时间段
			getTime(){
				let hours = new Date().getHours();
				if(hours >=6 && hours < 12){
					this.timeText = '早上好';
				}else if(hours >= 12 && hours < 18){
					this.timeText = '下午好';
				}else if(hours >= 18 && hours < 24){
					this.timeText = '晚上好';
				}else{
					this.timeText = '深夜好';
				}
			},
			
			//获取banner
			getbannerData(){
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				}),
				this.axios({
					method: 'GET',
					url: '/banner',
					//如果get请求，参数需要放在params,如果是post请求，参数需要放在data
					params:{
						appkey: this.appkey
					}
					
				}).then(result =>{
					this.$toast.clear();
					if(result.data.code == 300){
						this.bannerData = result.data.result;
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
		
			//获取热门推荐的
			getishotData(){
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				}),
				
				this.axios({
					method: 'GET',
					url: '/typeProducts',
					//如果get请求，参数需要放在params,如果是post请求，参数需要放在data
					params:{
						appkey: this.appkey,
						key: 'isHot',
						value: 1
					}
					
				}).then(result =>{
					this.$toast.clear();
					if(result.data.code == 500){
						this.ishotData = result.data.result;
					}
				}).catch(err =>{
					this.$toast.clear();

				})
			},
			
			//获取搜索的
			getSearchData(){
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				}),
				
				this.axios({
					method: 'GET',
					url: '/search',
					//如果get请求，参数需要放在params,如果是post请求，参数需要放在data
					params:{
						appkey: this.appkey,
						name: this.value
					}
					
				}).then(result =>{
					this.$toast.clear();
					if(result.data.code == "Q001"){
						this.searchData = result.data.result;
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
			//查看商品详情
			viewProductInfo(pid){
				this.$router.push({name: 'Detail', query: {pid}});
			},
			
			//获得个人信息
			getUserInfo(){
				//获取token
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return;
				}
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				this.axios({
					method: 'GET',
					url: '/findMy',
					params:{
						appkey: this.appkey,
						tokenString,
					}
				}).then(result =>{
					this.$toast.clear();
					if(result.data.code == 'A001'){
						if(result.data.result.length > 0){
							this.userInfo = result.data.result[0];
						}
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
		},
	}
</script>

<style lang="less" scoped>
	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		line-height: 150px;
		text-align: center;
		background-color: #39a9ed;
	}

	// .van-swipe__track {
	//     display: -webkit-box;
	//     display: -webkit-flex;
	//     display: flex;
	//     height: 250px !important;
	// }
</style>
